export const CATALOG_PAGE_PRODUCTS = `catalog-page-products`;
export const CATALOG_PAGE_CATEGORY = `catalog-page-category`;
export const CATALOG_PAGE_CMS_CATEGORY = `catalog-page-cms-category`;
